import {
    CLEAR_DISTRICT_LIST,
    SET_DISTRICT_FILTER_DATA,
    SET_DISTRICT_LIST,
    DISTRICT_CREATE_DIALOG_CLOSE,
    DISTRICT_CREATE_DIALOG_OPEN,
    DISTRICT_CREATE_ERROR,
    DISTRICT_CREATE_ERROR_CLEAR,
    DISTRICT_CREATE_PENDING,
    DISTRICT_EDIT_DIALOG_CLOSE,
    DISTRICT_EDIT_DIALOG_OPEN,
    DISTRICT_EDIT_ERROR,
    DISTRICT_EDIT_ERROR_CLEAR,
    DISTRICT_EDIT_PENDING,
    DISTRICT_FILTER_DIALOG_CLOSE,
    DISTRICT_FILTER_DIALOG_OPEN,
    DISTRICT_LIST_ERROR,
    DISTRICT_LIST_ERROR_CLEAR,
    DISTRICT_LIST_PENDING,
} from "./constants"


const initialDistrict = {

    //-----------------------------|| LIST ||---------------------------------------------------------------
    districtList: null,
    districtListCount: 0,
    isDistrictListPending: false,
    districtListErrorMessage: null,
    //-----------------------------|| FILTER ||-------------------------------------------------------------
    isDistrictFilterDialogOpen: false,
    districtFilterData: null,
    //-----------------------------|| CREATE ||-------------------------------------------------------------
    isDistrictCreateDialogOpen: false,
    isDistrictCreatePending: false,
    districtCreateErrorMessage: null,
    //-----------------------------|| EDIT ||---------------------------------------------------------------
    isDistrictEditDialogOpen: false,
    isDistrictEditPending: false,
    districtEditErrorMessage: null,
}

const districts = (district = initialDistrict, action) => {

    switch (action.type) {
        //-----------------------------|| LIST ||---------------------------------------------------------------
        case DISTRICT_LIST_PENDING: {
            return {
                ...district,
                isDistrictListPending: true,
                districtListErrorMessage: null,
            }
        }

        case SET_DISTRICT_LIST: {
            const { districtList } = action.payload || {};
            return {
                ...district,
                districtList: districtList['value'],
                districtListCount: districtList['@odata.count'],
                isDistrictListPending: false,
                districtListErrorMessage: null,
            }
        }

        case DISTRICT_LIST_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...district,
                districtListErrorMessage: errorMessage,
                isDistrictListPending: false,
                districtList: null,
                districtListCount: 0,
            }
        }

        case DISTRICT_LIST_ERROR_CLEAR: {
            return {
                ...district,
                districtListErrorMessage: null,
                isDistrictListPending: false,
            }
        }
        case CLEAR_DISTRICT_LIST: {
            return {
                ...district,
                districtList: null,
                districtListCount: 0,
            }
        }

        //-----------------------------|| FILTER ||-------------------------------------------------------------
        case DISTRICT_FILTER_DIALOG_OPEN: {
            return {
                ...district,
                isDistrictFilterDialogOpen: true,
            }
        }
        case DISTRICT_FILTER_DIALOG_CLOSE: {
            return {
                ...district,
                isDistrictFilterDialogOpen: false,
            }
        }

        case SET_DISTRICT_FILTER_DATA: {
            const { filter } = action.payload || {};
            return {
                ...district,
                districtFilterData: filter,
            }
        }

        //-----------------------------|| CREATE ||---------------------------------------------------------------
        case DISTRICT_CREATE_DIALOG_OPEN: {
            return {
                ...district,
                isDistrictCreateDialogOpen: true,
            }
        }
        case DISTRICT_CREATE_DIALOG_CLOSE: {
            return {
                ...district,
                isDistrictCreateDialogOpen: false,
            }
        }

        case DISTRICT_CREATE_PENDING: {
            return {
                ...district,
                isDistrictCreatePending: true,
                districtCreateErrorMessage: null,
            }
        }

        case DISTRICT_CREATE_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...district,
                districtCreateErrorMessage: errorMessage,
                isDistrictCreatePending: false,
            }
        }

        case DISTRICT_CREATE_ERROR_CLEAR: {
            return {
                ...district,
                districtCreateErrorMessage: null,
                isDistrictCreatePending: false,
            }
        }

        //-----------------------------|| EDIT ||---------------------------------------------------------------
        case DISTRICT_EDIT_DIALOG_OPEN: {
            return {
                ...district,
                isDistrictEditDialogOpen: true,
            }
        }
        case DISTRICT_EDIT_DIALOG_CLOSE: {
            return {
                ...district,
                isDistrictEditDialogOpen: false,
            }
        }

        case DISTRICT_EDIT_PENDING: {
            return {
                ...district,
                isDistrictEditPending: true,
                districtEditErrorMessage: null,
            }
        }

        case DISTRICT_EDIT_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...district,
                districtEditErrorMessage: errorMessage,
                isDistrictEditPending: false,
            }
        }

        case DISTRICT_EDIT_ERROR_CLEAR: {
            return {
                ...district,
                districtEditErrorMessage: null,
                isDistrictEditPending: false,
            }
        }

        default: {
            return district;
        }
    }
}

export default districts;